import { getEmailCommunicationPreferences } from '@calm/evexia-web-common/dist/circle';
import { EmailCommunicationType } from '@calm/evexia-web-common/dist/circle/types';
import { CircleCircle, NotificationUser } from '@calm/evexia-web-sdk';
import { useActiveCircle } from '@rhg/hooks/use-active-circle';
import { useNotificationUser } from '@rhg/hooks/use-notification-user';

export function getNeedsEmailOptInResponse(
    circle?: CircleCircle,
    notificationUser?: NotificationUser
) {
    return (
        !!circle &&
        getEmailCommunicationPreferences(circle) !==
            EmailCommunicationType.Enabled &&
        !notificationUser?.emailOptInStatusUpdatedAt
    );
}

export function useNeedsEmailOptInResponse() {
    const {
        activeCircle,
        isFetched: isActiveCircleFetched,
        isLoading: isActiveCircleLoading,
    } = useActiveCircle();
    const {
        notificationUser,
        isFetched: isNotificationDataFetched,
        isLoading: isNotificationDataLoading,
    } = useNotificationUser();
    return {
        isFetched: isActiveCircleFetched && isNotificationDataFetched,
        isLoading: isActiveCircleLoading || isNotificationDataLoading,
        needsEmailOptInResponse: getNeedsEmailOptInResponse(
            activeCircle,
            notificationUser
        ),
    };
}
